<template>
  <main-layout v-if="!isAuthPage">
    <router-view :key="$route.fullPath"/>
  </main-layout>
  <router-view v-else></router-view>

</template>

<script>
import MainLayout from './layouts/MainLayout.vue';
import {useRoute} from 'vue-router';
import {computed} from 'vue';

export default {
  name: 'App',
  components: {
    MainLayout
  },
  setup() {
    // Check for app version changes

    const route = useRoute();

    // Check if current route is an auth page (login/register)
    const isAuthPage = computed(() => {
      return route.name === 'login' ||
          route.path.includes('/login/') || route.name === 'register' || route.path.includes('/register/')||
          route.path.includes('/panel/') || route.name === 'panel'
          ;
    });

    return {
      isAuthPage
    };

  }
}
</script>